module.exports = __webpack_public_path__ + "static/media/logo-brand-gray-muted.b9cb6857.svg";